import { render, staticRenderFns } from "./HeaderUserStatus.vue?vue&type=template&id=52a87058"
import script from "./HeaderUserStatus.vue?vue&type=script&lang=js"
export * from "./HeaderUserStatus.vue?vue&type=script&lang=js"
import style0 from "./HeaderUserStatus.vue?vue&type=style&index=0&id=52a87058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports